import { CUSTOM_AVATAR_CONFIG } from '../constants';
import { apiFetch } from '../utils/apiFetch';
import type { CustomAvatarAudioResponse, ProcessCustomAvatarAudioParams } from '../dtos/customAvatar';

/**
 * POST /custom-avatar/audio
 *
 * Sends a speech audio blob to the 4-layer AI pipeline for transcription and processing.
 * apiFetch detects FormData bodies and omits Content-Type so the browser sets the
 * multipart boundary automatically.
 */
export const processCustomAvatarAudio = async (
  audioBlob: Blob,
  { sessionId, language = 'arabic', gender = 'male' }: ProcessCustomAvatarAudioParams
): Promise<CustomAvatarAudioResponse> => {
  const formData = new FormData();
  formData.append('audio', audioBlob, `audio.wav`);


  const response = await apiFetch({
    url: `${CUSTOM_AVATAR_CONFIG.BASE_URL}/custom-avatar/audio`,
    method: 'POST',
    params: { session_id: sessionId, language, gender },
    body: formData,
  });


  if (!response.ok) {
    throw new Error(`processCustomAvatarAudio failed: ${response.status} ${response.statusText}`);
  }

  return response.json() as Promise<CustomAvatarAudioResponse>;
};
